export const makeImgPropsList = ({ 320: w320, 640: w640, 960: w960 }) => ({
	srcSet: `
${process.env.PUBLIC_URL + "/" + w320} 320w,
${process.env.PUBLIC_URL + "/" + w640}
`,
	sizes: `50vw`,
	src: `${process.env.PUBLIC_URL}/${w320}`,
});

export default ({ 320: w320, 640: w640, 960: w960 }) => ({
	srcSet: `
${process.env.PUBLIC_URL + "/" + w320} 320w,
${process.env.PUBLIC_URL + "/" + w640} 640w,
${process.env.PUBLIC_URL + "/" + w960} 960w
`,
	sizes: `50vw`,
	src: `${process.env.PUBLIC_URL}/${w320}`,
});
